<template>
  <div
    class="relative laptop:col-span-2 largeDesktop:col-span-1 bg-[#fff]  pt-[20px]"
    :class="{ 'tablet:max-w-[95%] tablet:mx-auto largeDesktop:max-w-[500px] p-[30px] rounded-[20px] shadow-[0px_0px_20px_0px_#00000026]': mode != 'modal' }">
    <h4 v-if="mode != 'modal'" class="text-[20px] font-normal font-days text-[#333]">Welcome to</h4>
    <h4 v-if="mode != 'modal'" class="w-max relative mb-[10px] largeDesktop:mb-[15px] text-[24px] font-normal font-days text-[#2459A8]"><span
        class="text-[#F5B134]">My</span>HappyHome
        <!-- <img src="../../assets/images/tm-icon.svg" alt="Trademark Icon"
        class="w-[20px] h-[20px] absolute top-[3px] -right-[25px]"> -->
    </h4>
    <h2 v-if="mode != 'modal'"
      class="mb-[5px] text-[24px] largeDesktop:text-[40px] font-semibold font-poppins text-[#000]">Register Now
    </h2>
    <p class="text-[14px] largeDesktop:text-[16px] font-normal font-poppins text-[#666]">First time here? Register
      now
      and manage everything in one place.</p>
    <div
      class="mt-[10px] grid grid-cols-2 w-full mobile:gap-[15px] laptop:gap-[10px] laptop:pr-[5px] laptop:max-h-[350px] laptop:overflow-y-auto customScrollbar largeDesktop:max-h-[650px]"
      :class="{ 'max-h-[400px] overflow-y-auto pr-2.5': mode == 'modal' }">
      <div>
        <label for="firstName" class="pb-1 text-[14px] font-poppins text-[#666666]">First Name<span
            class="text-[#f00]">*</span></label>
        <inputComponent ref="firstNameRef" v-model="first_name" name="firstName" required
          errorClass="!text-customYellow-100" placeholder="First Name"
          customClass="!text-[16px] mobile:!p-[9px] largeDesktop:!p-[11px] !rounded-[5px] !border-[#CCCCCC]" />
      </div>
      <div>
        <label for="lastName" class="pb-1 text-[14px] font-poppins text-[#666666]">Last Name<span
            class="text-[#f00]">*</span></label>
        <inputComponent ref="lastNameRef" v-model="last_name" name="lastName" required
          errorClass="!text-customYellow-100" placeholder="Last Name"
          customClass="!text-[16px] mobile:!p-[9px] largeDesktop:!p-[11px] !rounded-[5px] !border-[#CCCCCC]" />
      </div>
      <div class="col-span-2">
        <label for="phoneNumber" class="pb-1 text-[14px] font-poppins text-[#666666]">Phone<span
            class="text-[#f00]">*</span></label>
        <inputComponent ref="phoneRef" v-model="phone" name="phone" required mask="(###) ###-####" type="tel"
          errorClass="!text-customYellow-100" placeholder="Enter Number" error-message="Invalid phone number"
          customClass="!text-[16px] mobile:!p-[9px] largeDesktop:!p-[11px] !rounded-[5px] !border-[#CCCCCC]" />
      </div>
      <div class="col-span-2">
        <label for="email" class="pb-1 text-[14px] font-poppins text-[#666666]">Email<span
            class="text-[#f00]">*</span></label>
        <inputComponent ref="emailRef" v-model="email" name="email" required :regex="$constants.EMAIL_REGEX"
          errorClass="!text-customYellow-100" error-message="Please enter a valid email address"
          placeholder="Enter Email"
          customClass="!text-[16px] mobile:!p-[9px] largeDesktop:!p-[11px] !rounded-[5px] !border-[#CCCCCC]" />
      </div>
      <div class="col-span-2 mt-[5px]">
        <p class="m-0 text-[12px] font-poppins text-[#999999]">By registering, you agree to the <a
            @click="contractorAgreementClicked" class="text-[#2459A8] underline cursor-pointer"> Terms & Conditions</a>
          <br>
          You may receive text messages from MyHappyHome related to your account, appointments, or verification (e.g.,
          2FA codes).
        </p>
      </div>
      <div class="col-span-2 my-2.5">
        <div class="flex desktop:items-start laptop:items-center mobile:items-start">
          <label class="flex items-start cursor-pointer mt-[3px]">
            <input type="checkbox" v-model="checkbox" class="hidden peer" />
            <span
              class="min-w-7 min-h-7 flex items-center justify-center border-[1px] !border-[#ccc] bg-white rounded-md transition">
              <svg v-if="checkbox == true" class="w-6 h-6 text-blue-600" fill="none" stroke="currentColor"
                stroke-width="2" stroke-linecap="round" stroke-linejoin="round" viewBox="0 0 20 20">
                <path d="M5 10.5 8.5 14 15 7.5" />
              </svg>
            </span>
          </label>
          <span class="ml-2 text-[12px] font-normal text-[#666666] text-justify font-poppins leading-tight">I agree to
            receive promotional text messages from MyHappyHome. Message frequency may vary. Message and data rates may apply.
            Reply STOP to opt out, HELP for help. <a @click="privacyPolicyClicked" _blank
              class="text-[#2459A8] underline cursor-pointer"> Privacy Policy.</a></span>
        </div>
      </div>
      <div class="col-span-2">
        <RecaptchaBox @verified="recaptchaVerified" ref="recaptchaRef" />
      </div>
      <div class="col-span-2 text-center mt-[5px]">
        <button :disabled="isSubmitDisabled()" @click="submitClicked"
          class="CustomYellowBtn mobile:px-8 mobile:py-1.5 largeDesktop:px-[60px] largeDesktop:py-[10px] rounded-full font-poppins font-medium text-[16px] largeDesktop:text-[18px] w-max mx-auto disabled:border-[#EFEFEF] disabled:bg-gradient-to-r disabled:from-[#EFEFEF] disabled:to-[#EFEFEF] disabled:hover:bg-gradient-to-r disabled:hover:from-[#EFEFEF] disabled:hover:to-[#EFEFEF] disabled:!text-[#999999] disabled:cursor-not-allowed focus:outline-none "
          type="submit">SUBMIT</button>
        <p class="mt-4 text-sm mb-0 text-center font-poppin text-[#999999]">Already have an account? <span
            @click="loginClicked()" class="cursor-pointer text-[#2459A8]">Sign in</span> </p>
      </div>
      <div class="col-span-2 mt-[5px] laptop:mt-0">
        <termsAndPrivacyComponent />
      </div>
    </div>
  </div>
</template>
<script>
import inputComponent from '../../components/partialComponent/inputComponent.vue';
import RecaptchaBox from '../../components/partialComponent/recaptchaBox.vue'
import { useToast } from "vue-toastification";
import { mapActions, mapGetters } from "vuex";
import termsAndPrivacyComponent from './termsAndPrivacyComponent.vue';
const toast = useToast();
 export default {
  props: ["callbacks", "mode"],
  components: {
    inputComponent,
    RecaptchaBox,
    termsAndPrivacyComponent,
  },
  data() {
    return {
      checkbox: false,
      phone: null,
      first_name: null,
      last_name: null,
      email: null,
      loading: false,
      isValidate: false,
      recaptchaToken: null,
      provider: null,
      provider_id: null,
    };
  },


  computed: {
    ...mapGetters([
      "userRegisterResponse",
    ]),
  },

  watch: {
    userRegisterResponse: function () {
      if (this.userRegisterResponse != null) {
        if (this.userRegisterResponse.status == true) {
          this.saveState()
          toast.success(this.userRegisterResponse.message)
          if (this.callbacks) {
            this.callbacks("verification")
          }
        } else {
          toast.error(this.userRegisterResponse.message)
        }
      }
    },
  },

  mounted() {
    document.body.style.position = '';
    document.body.style.overflow = '';
    document.body.classList.remove('modal-open');

    const savedData = JSON.parse(localStorage.getItem('registerFormData')) ?? null
    if (savedData) {
      this.email = savedData.email
      this.first_name = savedData.first_name
      this.last_name = savedData.last_name
      this.provider = savedData.provider
      this.provider_id = savedData.provider_id
    }
    // this.getPrivacyPolicyDetails()
  },

  beforeUnmount() {
    document.body.style.position = '';
    document.body.style.overflow = '';
  },

  methods: {
    ...mapActions([
      "userRegister",
    ]),

    isSubmitDisabled() {
      if (this.recaptchaToken && this.checkbox) {
        return false
      } else {
        return true
      }
    },
    recaptchaVerified(token) {
      this.recaptchaToken = token;
    },


    submitClicked() {

      const refsToValidate = [
        this.$refs.firstNameRef,
        this.$refs.lastNameRef,
        this.$refs.emailRef,
        this.$refs.phoneRef,
      ];
      this.isValidate = true

      let firstInvalidRef = null;


      for (const ref of refsToValidate) {
        if (ref?.validate?.()) {
          if (!firstInvalidRef) firstInvalidRef = ref;
        }
      }

      if (firstInvalidRef) {
        // Scroll to and focus the first invalid field
        firstInvalidRef.$el.scrollIntoView({ behavior: 'smooth', block: 'center' });
        const inputEl = firstInvalidRef.$el.querySelector('input');
        inputEl?.focus();
        return;
      }

      if (!this.recaptchaToken) {
        toast.error("You must verify the reCAPTCHA before continuing.");
        return;
      }

      this.callUserRegister()
    },

    callUserRegister() {
      let payload = {
        "first_name": this.first_name,
        "last_name": this.last_name,
        "email": this.email.trim(),
        "phone": this.$helper.extractPhoneNumber(this.phone),
        "recaptcha_token": this.recaptchaToken
      }
      if (this.provider_id) {
        payload['provider_id'] = this.provider_id
        payload['provider'] = this.provider
      }
      this.$refs.recaptchaRef.resetCall()
      this.recaptchaToken = null
      this.userRegister(payload)

    },

    saveState() {
      const formData = {
        phone: this.phone,
        first_name: this.first_name,
        last_name: this.last_name,
        email: this.email.trim(),
      };
      localStorage.setItem('registerFormData', JSON.stringify(formData));
    },

    loginClicked() {
      localStorage.removeItem('registerFormData')
      if (this.callbacks) {
        this.callbacks("login")
      }
    },

    privacyPolicyClicked() {
      const url = this.$router.resolve({ name: "privacyPolicy" }).href;
      window.open(url, "_blank");
    },

    contractorAgreementClicked() {
      const url = this.$router.resolve({ name: "termsAndConditions" }).href;
      window.open(url, "_blank");
    }

  },

};
</script>
